import {registerDictionary} from '@/commons/popupRegister/dictionaryRegister.js';
import {registerCommonPopup} from '@/commons/popupRegister/commonPopupRegister.js';
import {registerEstimate} from '@/commons/popupRegister/estimateRegister.js';
import {registerTYEstimate} from '@/commons/popupRegister/estimateTYRegister.js';
import {registerEnactDictionary} from '@/commons/popupRegister/enactDictionaryRegister.js';
import {registerExamine} from '@/commons/popupRegister/examineRegister';
import {registerReturn} from '@/commons/popupRegister/returnRegister';
import {registerSummaryEstimate} from '@/commons/popupRegister/summaryEstimateRegister';
import {syncDictionary} from '@/commons/popupRegister/syncDictionaryRegister.js';
import {estimateArrgrateRegister} from '@/commons/popupRegister/estimateArrgrateRegister.js';
import {estimateSectorWideRegister} from '@/commons/popupRegister/estimateSectorWideRegister.js';
import {registerReport} from '@/commons/popupRegister/reportRegister.js';
import {registerAllocationImplement} from '@/commons/popupRegister/allocationImplementRegister.js';
import {allocationDeliverRegister} from '@/commons/popupRegister/allocationDeliverRegister.js';
import {registerThreeYearEstimate} from '@/commons/popupRegister/estimateThreeYearRegister.js';
import {auditRegister} from '@/commons/popupRegister/auditRegister.js';
import {registerMisaAva} from '@/commons/popupRegister/misaAvaRegister';
import {registerBeforeData} from '@/commons/popupRegister/beforeDataRegister.js';
import {estimateArrgrateThreeYearRegister} from '@/commons/popupRegister/estimateArrgrateThreeYearRegister.js';
import {registerSummaryEstimateThreeYear} from '@/commons/popupRegister/summaryEstimateThreeYearRegister';
import {estimateDecisionRegister} from '@/commons/popupRegister/estimateDecisionRegister.js';
import {allocationRegister} from '@/commons/popupRegister/allocationRegister';
import {settingRegister} from '@/commons/popupRegister/settingRegister.js';
import {estimateInitialRegister} from '@/commons/popupRegister/estimateInitialRegister.js';
import {registerSummaryEstimateInitial} from '@/commons/popupRegister/summaryEstimateInitialRegister.js';
import {registerSummaryEstimateInitialAggregate} from '@/commons/popupRegister/summaryEstimateInitialAggregateRegister.js';
import {auditReceiveInitialRegister} from '@/commons/popupRegister/auditReceiveInitialRegister.js';
import {popupTrackingRegister} from '@/commons/popupRegister/tracking/trackingRegister.js';
import {systemRegister} from '@/commons/popupRegister/systemRegister.js';

export function register(app) {
  registerDictionary(app);
  registerCommonPopup(app);
  registerEstimate(app);
  registerTYEstimate(app);
  registerEnactDictionary(app);
  registerExamine(app);
  registerReturn(app);
  registerSummaryEstimate(app);
  syncDictionary(app);
  estimateArrgrateRegister(app);
  estimateSectorWideRegister(app);
  registerReport(app);
  registerThreeYearEstimate(app);
  auditRegister(app);
  registerMisaAva(app);
  registerBeforeData(app);
  estimateArrgrateThreeYearRegister(app);
  registerSummaryEstimateThreeYear(app);
  estimateDecisionRegister(app);
  allocationRegister(app);
  registerAllocationImplement(app);
  settingRegister(app);
  allocationDeliverRegister(app);
  estimateInitialRegister(app);
  registerSummaryEstimateInitial(app);
  registerSummaryEstimateInitialAggregate(app);
  auditReceiveInitialRegister(app);
  popupTrackingRegister(app);
  systemRegister(app);
}
